import { giphyBlack } from '@giphy/js-brand'
import { ReactNode } from 'react'
import { ControlSize } from 'types'
import { IconButtonProps } from '../../icon-button'
import { Button, Header, Label, LabelText } from './style'
import Icon from '../../../../types/icons'

type Props = {
    buttonOptions?: Partial<IconButtonProps>
    className?: string
    controlColor: string
    isOpen?: boolean
    label?: ReactNode
    size?: ControlSize
    onToggle?: (open: boolean) => void
    icon?: Icon
}

const CollapseHeader = ({
    buttonOptions,
    className,
    controlColor,
    isOpen = false,
    label,
    size,
    onToggle,
    icon = 'navigate-down',
}: Props) => {
    return (
        <Header className={className} controlColor={controlColor}>
            <Label>{typeof label === 'string' ? <LabelText>{label}</LabelText> : label}</Label>
            <Button
                color={giphyBlack}
                iconScale={0.9}
                {...buttonOptions}
                icon={icon}
                isOpen={isOpen}
                size={size}
                onClick={() => onToggle?.(!isOpen)}
            />
        </Header>
    )
}

export default CollapseHeader
